export default function initNavbar() {
    const body = document.body;
    const mobileToggle = document.querySelector('.cdr-navbar__toggle');
    const mobileMenu = document.querySelector('.cdr-mobile-menu');
    const mobileLinks = document.querySelectorAll('.cdr-mobile-menu__link');

    const closeMobileMenu = () => {
        if (mobileMenu && mobileMenu.classList.contains('active')) {
            mobileToggle.classList.remove('active');
            mobileMenu.classList.remove('active');
            body.classList.remove('body--is-menu-open');
        }
    };

    if (mobileToggle && mobileMenu) {
        mobileToggle.addEventListener('click', (e) => {
            e.stopPropagation();
            const isActive = mobileMenu.classList.contains('active');

            // Close other floating menus if they exist (global events will handle detail)
            if (!isActive) {
                document.dispatchEvent(new CustomEvent('cdr:close-floating-menus'));
            }

            mobileToggle.classList.toggle('active');
            mobileMenu.classList.toggle('active');
            body.classList.toggle('body--is-menu-open');
        });

        mobileLinks.forEach(link => {
            link.addEventListener('click', closeMobileMenu);
        });
    }

    // Listen for global close events
    document.addEventListener('cdr:close-mobile-menu', closeMobileMenu);

    // Click outside to close
    document.addEventListener('click', (e) => {
        if (mobileMenu && !mobileMenu.contains(e.target) && !mobileToggle.contains(e.target)) {
            closeMobileMenu();
        }
    });
}
